module.exports = __webpack_public_path__ + "media/images/sp/components/specials/cv_button/reserve_sameday-a57c779e1e8963c3048a4b01e0e56954.svg";